@if (visible()) {
    <app-button
        icon="pi-ellipsis-v"
        [rounded]="true"
        [text]="true"
        (clickEvent)="actionsMenu.toggle($event)"
    ></app-button>
    <p-menu #actionsMenu [model]="menuItems()" [popup]="true" appendTo="body"></p-menu>
}
